import React, { useState } from 'react'

import {
  Box,
  Button,
  Chip,
  Hidden,
  Paper,
  TablePagination,
} from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { reverse } from 'named-urls'
import { useHistory } from 'react-router-dom'
import { isEmpty } from 'lodash'

import { LoadingFeedback, MenuButton } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { DeleteAiInventoryModal } from './components'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import usePermissions from 'hooks/usePermissions'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'
import { routes } from 'Routes'
import useStyles from './styles'

const AiInventoryTable = ({ filter }) => {
  const classes = useStyles()
  const history = useHistory()
  const { permitted } = usePermissions()
  const canManage = permitted(constants.permissions.AI_INVENTORY.MANAGE)
  const canShow = permitted(constants.permissions.AI_INVENTORY.SHOW)

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [selectedAiInventoryId, setSelectedAiInventoryId] = useState(null)

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.aiInventory.get,
    { ...filter.filters, perPage, page },
    [filter.filters, perPage, page],
  )

  const aiInventories = response?.data?.aiInventoryItems || []
  const meta = response?.data?.meta || {}

  const { RISK, RISK_CLASS } = constants.aiInventory

  const handleOpenDeleteModal = (aiInventoryId) => {
    setSelectedAiInventoryId(aiInventoryId)
    setOpenDeleteModal(true)
  }

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Paper>
        <Box width="100%">
          <PerfectScrollbar
            options={{ wheelPropagation: false, useBothWheelAxes: true }}
          >
            <Table
              size="small"
              noWrap
              emptyMessage="Nenhum inventário de IA encontrado."
            >
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Provedor</TableCell>
                  <TableCell>Departamento</TableCell>
                  <TableCell>Risco</TableCell>
                  <TableCell>Última Alteração</TableCell>
                  <TableCell align="center" width="5%">
                    Ações
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {aiInventories.map((item) => (
                  <TableRow key={item.id}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>
                      <Box className={classes.iconCell}>
                        {item.aiInventoryTool?.iconUrl && (
                          <img
                            src={item.aiInventoryTool.iconUrl}
                            alt=""
                            className={classes.toolIcon}
                          />
                        )}
                        {item.name || '—'}
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box className={classes.iconCell}>
                        {item.aiInventoryTool?.aiInventoryProvider?.iconUrl && (
                          <img
                            src={
                              item.aiInventoryTool.aiInventoryProvider.iconUrl
                            }
                            alt=""
                            className={classes.toolIcon}
                          />
                        )}
                        {item.aiInventoryTool?.aiInventoryProvider?.name || '—'}
                      </Box>
                    </TableCell>
                    <TableCell>
                      {item.allDepartments ? (
                        <div>Todos os departamentos</div>
                      ) : !isEmpty(item.departments) ? (
                        item.departments.map((department) => (
                          <div key={department.id}>{department.name}</div>
                        ))
                      ) : (
                        '—'
                      )}
                    </TableCell>
                    <TableCell>
                      {item.risk ? (
                        <Chip
                          size="small"
                          label={RISK[item.risk] || item.risk}
                          className={classes[RISK_CLASS[item.risk]]}
                        />
                      ) : (
                        '—'
                      )}
                    </TableCell>
                    <TableCell>
                      {helpers.formatters.dates.ptBrFormatDate(item.updatedAt)}
                    </TableCell>
                    <TableCell align="center" size="small">
                      {(canManage || canShow) && (
                        <MenuButton>
                          {canShow && (
                            <Button
                              color="secondary"
                              fullWidth
                              size="small"
                              onClick={() =>
                                history.push(
                                  reverse(routes.aiInventory.show, {
                                    aiInventoryId: item.id,
                                  }),
                                )
                              }
                            >
                              Visualizar
                            </Button>
                          )}
                          {canManage && (
                            <>
                              <Button
                                color="secondary"
                                fullWidth
                                size="small"
                                onClick={() =>
                                  history.push(
                                    reverse(routes.aiInventory.edit, {
                                      aiInventoryId: item.id,
                                    }),
                                  )
                                }
                              >
                                Editar
                              </Button>
                              <Button
                                color="secondary"
                                fullWidth
                                size="small"
                                onClick={() => handleOpenDeleteModal(item.id)}
                              >
                                Excluir
                              </Button>
                            </>
                          )}
                        </MenuButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </PerfectScrollbar>
        </Box>
        <TablePagination
          component="div"
          count={meta.totalCount || 0}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          rowsPerPage={perPage}
          rowsPerPageOptions={[10, 25, 50]}
          labelRowsPerPage={<Hidden smDown>Por página</Hidden>}
          nextIconButtonProps={{ size: 'small' }}
          backIconButtonProps={{ size: 'small' }}
        />
      </Paper>

      {openDeleteModal && (
        <DeleteAiInventoryModal
          open={openDeleteModal}
          setOpen={setOpenDeleteModal}
          refresh={refresh}
          aiInventoryId={selectedAiInventoryId}
        />
      )}
    </>
  )
}

export default AiInventoryTable
